import { howManyDigitsAfterDecimalPoint, isNumericInput } from '@/utils/number';

export const productCodeRules = [
  {
    max: 25,
    message: 'Product Code cannot be longer than 25 characters',
  },
];

export const productDescriptionRules = [
  {
    max: 150,
    message: 'Product Description cannot be longer than 150 characters',
  },
];

export const quantityRules = (t) => [
  {
    validator: (_, value) => {
      if (value || value === '0' || value === 0) {
        if (Number(value) <= 0) {
          return Promise.reject(t('translation:getQuote.productDetails.numberOfPackages.disableNegative'));
        }

        if (
          !isNumericInput(typeof value === 'string' ? value.replace(/,/i, '.') : value) ||
          howManyDigitsAfterDecimalPoint(value) > 0
        ) {
          return Promise.reject('Quantity can only be an integer');
        }

        return Promise.resolve();
      }

      return Promise.reject(t('translation:getQuote.productDetails.numberOfPackages.message'));
    },
    required: true,
  },
];

export const weightRules = (t) => [
  {
    validator: (_, value) => {
      if (value || value === '0' || value === 0) {
        if (Number(value) <= 0) {
          return Promise.reject(t('translation:getQuote.productDetails.weight.disableNegative'));
        }

        if (!isNumericInput(typeof value === 'string' ? value.replace(/,/i, '.') : value)) {
          return Promise.reject('Weight can contain only digits and one "." or ","');
        }

        if (howManyDigitsAfterDecimalPoint(value) > 2) {
          return Promise.reject('Weight cannot have more than two digits after the decimal point');
        }

        return Promise.resolve();
      }

      return Promise.reject(t('translation:getQuote.productDetails.weight.message'));
    },
    required: true,
  },
];

export const weightUomRules = (t) => [
  {
    required: true,
    message: t('translation:getQuote.productDetails.weightUom.message'),
  },
];

export const lengthRules = (t) => [
  {
    validator: (_, value) => {
      if (value || value === '0' || value === 0) {
        if (Number(value) <= 0) {
          return Promise.reject(t('translation:getQuote.productDetails.length.disableNegative'));
        }

        if (!isNumericInput(typeof value === 'string' ? value.replace(/,/i, '.') : value)) {
          return Promise.reject('Length can contain only digits and one "." or ","');
        }

        if (howManyDigitsAfterDecimalPoint(value) > 2) {
          return Promise.reject('Length cannot have more than two digits after the decimal point');
        }

        return Promise.resolve();
      }

      return Promise.reject(t('translation:getQuote.productDetails.length.message'));
    },
    required: true,
  },
];

export const widthRules = (t) => [
  {
    validator: (_, value) => {
      if (value || value === '0' || value === 0) {
        if (Number(value) <= 0) {
          return Promise.reject('Width must be greater than 0');
        }

        if (!isNumericInput(typeof value === 'string' ? value.replace(/,/i, '.') : value)) {
          return Promise.reject('Width can contain only digits and one "." or ","');
        }

        if (howManyDigitsAfterDecimalPoint(value) > 2) {
          return Promise.reject('Width cannot have more than two digits after the decimal point');
        }

        return Promise.resolve();
      }

      return Promise.reject(t('translation:getQuote.productDetails.width.message'));
    },
    required: true,
  },
];

export const heightRules = (t) => [
  {
    validator: (_, value) => {
      if (value || value === '0' || value === 0) {
        if (Number(value) <= 0) {
          return Promise.reject('Height must be greater than 0');
        }

        if (!isNumericInput(typeof value === 'string' ? value.replace(/,/i, '.') : value)) {
          return Promise.reject('Height can contain only digits and one "." or ","');
        }

        if (howManyDigitsAfterDecimalPoint(value) > 2) {
          return Promise.reject('Height cannot have more than two digits after the decimal point');
        }

        return Promise.resolve();
      }

      return Promise.reject(t('translation:getQuote.productDetails.height.message'));
    },
    required: true,
  },
];

export const dimUomRules = (t) => [
  {
    required: true,
    message: t('translation:getQuote.productDetails.dimUom.message'),
  },
];

export const cubeRules = (t) => [
  {
    validator: (_, value) => {
      if (value || value === '0' || value === 0) {
        if (Number(value) <= 0) {
          return Promise.reject('Cube must be greater than 0');
        }

        if (!isNumericInput(typeof value === 'string' ? value.replace(/,/i, '.') : value)) {
          return Promise.reject('Cube can contain only digits and one "." or ","');
        }

        if (howManyDigitsAfterDecimalPoint(value) > 3) {
          return Promise.reject('Cube cannot have more than three digits after the decimal point');
        }

        return Promise.resolve();
      }

      return Promise.reject(t('translation:getQuote.productDetails.cube.message'));
    },
    required: true,
  },
];

export const additionalValidationRules = (form) => [
  {
    validator: (_, _value) => {
      const itemsValue = form.getFieldValue('items');
      if (!itemsValue?.length || itemsValue.length < 1) {
        return Promise.reject('At least one product must be added');
      }
      return Promise.resolve();
    },
    required: true,
  },
];
